@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/common" as c;

$clear-btn-text-color: v.$palette-gray-300;
$clear-btn-active-text-color: v.$palette-gray-900;
$clear-btn-active-bg-color: v.$palette-blue-light-2;
$clear-btn-active-color: v.$palette-blue;

.filter {
  flex: 0 0 5%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: static;

  &.filterReverse {
    justify-content: end;
  }

  .back {
    color: v.$palette-gray-900;
    @include t.text(14px, 14px, 500);
    background-color: transparent;
    border: none;
    box-shadow: none;
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;

    .back-icon {
      margin-right: 4px;
      transform: rotate(180deg);
    }
  }

  .button {
    font-family: v.$primary-font;
    background-color: v.$palette-gray-200;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    padding: 0;
    border: none;
    user-select: none;
    transition: background-color 250ms, color 250ms;

    svg path {
      fill: v.$palette-gray-900;
    }

    &:hover {
      background-color: v.$palette-blue-light-2;
      color: v.$palette-blue;

      svg path {
        fill: v.$palette-blue;
      }
    }

    &.isOpenFilter {
      background-color: v.$palette-blue-light-5;
      color: v.$palette-blue;

      svg {
        path {
          fill: v.$palette-blue;
        }
      }
    }
  }
}

.btnTitle {
  @include t.text(14px, 16px, 500);
}

.filterContent {
  position: absolute;
  top: 200px;
  right: 16px;
  z-index: v.$z-index-global-filter-content;
  width: calc(100% - 32px);
  background-color: v.$palette-white;
  box-shadow: 0 10px 30px #{v.$shadow-color-1};
  border-radius: 10px;
  padding: 24px 24px;
}

.propTitle {
  @include t.text(10px, 12px, 700);
  letter-spacing: 0.04em;
  text-transform: uppercase;

  color: $clear-btn-active-text-color;
}

.title {
  margin-bottom: 8px;
}

.btnContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;

  p {
    @include t.text(16px, 26px, 600);
    color: v.$palette-gray-900;
  }
}

.btnsWrap {
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 10px;
}

.clearBtn {
  @include t.text(14px, 16px, 600);
  color: $clear-btn-active-text-color;
  cursor: pointer;
}

.btnCancel {
  margin-left: auto;
}

.btnSave {
  margin-left: 8px;
  border-radius: 6px;
}

.selectWrap {
  position: relative;
}

.dropDown {
  width: 100%;
}

.fieldWrap {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  width: 100%;

  & > .field {
    width: 100%;
  }
}

.separator {
  margin: 24px 0;
  border: 0.5px solid v.$palette-gray-200;
  border-radius: 10px;
}

:global([data-theme="dark"]) {
  .filter .button:not(:hover):not(.isOpenFilter) svg path {
    fill: v.$palette-pure-white;
  }
}
